import { Grid, TextButton } from '@tfo/common'
import { inject } from 'mobx-react'
import * as React from 'react'
import { injectIntl, WrappedComponentProps } from 'react-intl'
import { useHistory } from 'react-router-dom'
import IndividualHeader from '../../common/individual-header/IndividualHeader'
import { AgeRestrictionViewModel } from '../../ViewModels'

import './AgeRestriction.scss'

type AgeRestrictionProps = AgeRestrictionViewModel

const { GridWrapper } = Grid

const AgeRestriction: React.FunctionComponent<AgeRestrictionProps &
    WrappedComponentProps> = props => {
    const {nationalId, companyName, orderId} = props
    const history = useHistory()
    return (
        <GridWrapper className={'IndividualView AgeRestriction'}>
            <IndividualHeader
                companyName={companyName}
                headingId="ageRestriction.heading"
                preambleId="ageRestriction.body"
                preambleData={{
                    nationalId: nationalId,
                    companyName: companyName,
                }}
            />

            <div className={'IndividualButtons'}>
                <TextButton
                    className="AgeRestriction__TextButton AgeRestriction__TextButton--left"
                    onClick={() =>
                        history.push(`/approval/${orderId}`)
                    }>
                    {props.intl.formatMessage({ id: 'ageRestriction.btn.change' })}
                </TextButton>
            </div>
        </GridWrapper>
    )
}

export default inject('rootStore')(injectIntl(AgeRestriction))
